import React, { CSSProperties, FormEvent, memo, ReactNode } from 'react';
import { Box } from 'src/components/Box';
import FormField from 'src/components/FormField';
import { Margins, Responsive } from 'src/design-system/style-types';

import { TextArea } from './TextArea';

interface Props {
  charCount?: boolean;
  className?: string;
  disabled?: boolean;
  err?: string | false;
  /** Help text - don't use more than 80 chars */
  help?: ReactNode;
  label?: ReactNode;
  marginBottom?: Responsive<Margins>;
  maxLength?: number;
  name?: string;
  onBlur?: (event: FormEvent<HTMLTextAreaElement>) => void;
  onChange?: (event: FormEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  resize?: CSSProperties['resize'];
  rows?: number;
  requiredIndicator?: ReactNode;
  size?: 'small' | 'normal';
  touched?: boolean;
  value?: string;
  autoFocus?: boolean;
}

const _TextAreaField = ({
  charCount = false,
  className = '',
  disabled = false,
  err = false,
  help = '',
  label = '',
  marginBottom = '0',
  maxLength = 1000,
  name = '',
  onBlur = () => {},
  onChange = () => {},
  placeholder = '',
  requiredIndicator = undefined,
  resize,
  rows,
  size = 'normal',
  touched = false,
  value = '',
  autoFocus = false,
}: Props) => (
  <FormField
    className={className}
    disabled={disabled}
    err={err}
    help={help}
    name={name}
    label={
      charCount ? (
        <Box wrap="nowrap" data-qa="character-count">
          <Box>{label}</Box>
          {value.length}/{maxLength}
        </Box>
      ) : (
        label
      )
    }
    requiredIndicator={requiredIndicator}
    marginBottom={marginBottom}
    touched={touched}
  >
    <TextArea
      autoFocus={autoFocus}
      disabled={disabled}
      err={err}
      name={name}
      onBlur={onBlur}
      onChange={onChange}
      placeholder={placeholder}
      rows={rows}
      touched={touched}
      value={value}
      resize={resize}
      size={size}
    />
  </FormField>
);

export const TextAreaField = memo(_TextAreaField);
